// extracted by mini-css-extract-plugin
export default {"highlightBox":"HighlightBox_highlightBox__2cbto"};